﻿'use strict';

angular.module('ntmApp').factory('ReAssignRescheduleActivityLeeWayValidator', [function () {

    function ReAssignRescheduleActivityLeeWayValidator(activity, targetDate, targetHeader) {

        this.activity = activity;
        this.targetDate = targetDate;
        this.targetHeader = targetHeader;

        this.isValid = function () {
            var plannedDate = moment(this.activity.datePlanned);
            var targetScheduleDate = moment(this.targetDate);

            var afterLeewayDate = moment(plannedDate).add(this.activity.afterLeeway, 'days');
            var beforeLeewayDate = moment(plannedDate).subtract(this.activity.beforeLeeway, 'days');


            return this.activity.recurrs === 'Weekly' || this.activity.recurrs === 'Monthly' || this.activity.recurrs === 'Yearly' ?
                        !(afterLeewayDate.isBefore(targetScheduleDate) || beforeLeewayDate.isAfter(targetScheduleDate)) :
                        true;
        };

        this.warningMessage = function () {

            var plannedDate = moment(this.activity.datePlanned);
            var targetScheduleDate = moment(this.targetDate);

            var minPlannedDate = moment(plannedDate).subtract(this.activity.beforeLeeway, 'days');
            var maxPlannedDate = moment(plannedDate).add(this.activity.afterLeeway, 'days');

            if (this.activity.personId === this.targetHeader.personId) {
                return "Warning: this activities leeway is between {0} and {1}. <br /><br /> Move activity to {2} anyway?"
                       .format(minPlannedDate.format('MM/DD/YYYY'), maxPlannedDate.format('MM/DD/YYYY'), targetScheduleDate.format('MM/DD/YYYY'));
            } else {
                return "Warning: this activity's leeway is between {0} and {1}. <br /><br /> {4} to {2} and move to {3} anyway?"
                        .format(minPlannedDate.format('MM/DD/YYYY'), maxPlannedDate.format('MM/DD/YYYY'), this.targetHeader.staffName, targetScheduleDate.format('MM/DD/YYYY'), this.activity.personId ? 'Reassign' : 'Assign');
            }
        };
    }

    return (ReAssignRescheduleActivityLeeWayValidator);
}]);